import React from 'react';
import { useField, useForm } from 'react-final-form';
import { styled } from '@linaria/react';

import { PAPER_SIZE_VALUES } from '../../constants';

const StyledHint = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--bb-hint-background);
  border-radius: var(--bb-hint-border-radius);
  padding-top: var(--bb-hint-padding-top);
  padding-right: var(--bb-hint-padding-right);
  padding-bottom: var(--bb-hint-padding-bottom);
  padding-left: var(--bb-hint-padding-left);
  white-space: nowrap;
  margin-left: 12px;
  min-width: 130px;
  box-sizing: border-box;
  color: var(--bb-hint-color);
  user-select: none;
  border: 3px solid transparent;
  transition:
    color 0.1s,
    border 0.1s;
  &:hover {
    color: var(--bb-color-primary-0);
    cursor: pointer;
  }
  &:active,
  &:focus {
    border: 3px solid var(--bb-color-secondary-3);
  }
`;
const PaperSizeHintButton = props => {
  const { mutators } = useForm();
  const { input } = useField('paper-size-type');
  const handleClick = () => {
    const value =
      input.value === PAPER_SIZE_VALUES.PAGES ? PAPER_SIZE_VALUES.WORDS : PAPER_SIZE_VALUES.PAGES;
    mutators.applyPaperSizeType(value);
  };
  return (
    <StyledHint
      onClick={handleClick}
      {...props}
    />
  );
};

export default PaperSizeHintButton;
